import { inject } from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {EMPTY, Observable, } from "rxjs";
import { EventService } from "@services";
import { EventFilter, EventFilterParams, EventItem, EventItemType, FindEventsRequest, ListSortOrder } from "@model";
import { EVENT_CALENDAR_ROUTE, FINISHED_EVENTS_ROUTE } from "../app-routing.module";

export function createEventCalendarResolver(eventItemType: EventItemType): ResolveFn<Observable<EventItem[]> |
  Promise<EventItem[]> | EventItem[] | []> {
  return (route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot,
          eventService: EventService = inject(EventService),
          router: Router =inject(Router)):
    Observable<EventItem[]> |
    Promise<EventItem[]> | EventItem[] | [] => {
    let [eventFilterParams, paramsValid]: [EventFilterParams, boolean] = getParams(route, eventItemType);
    if (!paramsValid) {
      router.navigate([eventItemType === EventItemType.FINISHED ? FINISHED_EVENTS_ROUTE : EVENT_CALENDAR_ROUTE])
      return EMPTY;
    }
    if (eventItemType === EventItemType.FINISHED) {
      return eventService.filterFinishedEventsList(FindEventsRequest.createEventPageFilter(
        1, eventFilterParams, ListSortOrder.ASC));
    }
    if (eventItemType === EventItemType.UPCOMING) {
      return eventService.findEventCalendarList(FindEventsRequest.createEventPageFilter(
        1, eventFilterParams, ListSortOrder.DESC));
    }
    return [];
  };
}
function getParams(route: ActivatedRouteSnapshot, eventItemType: EventItemType): [EventFilterParams, boolean] {
  let eventFilterParams: EventFilterParams = eventItemType === EventItemType.FINISHED ?
    EventFilterParams.finishedEventsParams() : EventFilterParams.eventCalendarParams()
  let valid: boolean = true;

  let sportId: number = +route.queryParams["sport"];
  let name = route.queryParams["name"] ? route.queryParams["name"] : "";
  let dateFrom = route.queryParams["dateFrom"];
  let dateTo = route.queryParams["dateTo"];
  let length: number = +route.queryParams["length"];
  if (sportId) {
    eventFilterParams.sport = sportId;
  }
  if (length) {
    if (EventFilter.LENGTHS.includes(length)) {
      eventFilterParams.length = length;
    }
    else {
      valid = false;
    }
  }
  let dateFromParam: number | undefined = eventFilterParams.dateFrom;
  let dateToParam: number | undefined = eventFilterParams.dateTo;
  if (dateFrom) {
    if (!isNaN((new Date(dateFrom)).getTime())) {
      dateFromParam = new Date(dateFrom).getTime()
    }
    else {
      valid = false;
    }
  }
  if (dateTo) {
    if (!isNaN((new Date(dateTo)).getTime())) {
      dateToParam = new Date(dateTo).getTime()
    }
    else {
      valid = false;
    }
  }
  else if (eventItemType === EventItemType.FINISHED && dateToParam && eventFilterParams.dateTo && dateToParam > eventFilterParams.dateTo) {
    valid = false;
  }
  else if (eventItemType === EventItemType.UPCOMING && dateFromParam && eventFilterParams.dateFrom && dateFromParam < eventFilterParams.dateFrom) {
    valid = false;
  }
  if (dateFromParam && dateToParam && valid) {
    valid = dateFromParam < dateToParam;
  }
  if (valid) {
    eventFilterParams.dateFrom = dateFromParam;
    eventFilterParams.dateTo = dateToParam;
  }

  if (name && name.trim().length > 0) {
    eventFilterParams.name = name
  }
  return [eventFilterParams, valid];
}


